import RechargeMultiple from "./recharge-multiple.vue";
import RechargeOpen from "./recharge-open.vue";
import RechargeTax from "./recharge-tax.vue";
import GenericSummary from "../../common/generic-summary.vue";
import sales from "../../../services/sales";
import auth from "../../../services/auth";
import messageDialog from "../../../components/message-dialog.vue";
import successPage from "../../common/adhesion/success.vue";
import errorPage from "../../common/adhesion/error.vue";

export default {
  data() {
    return {
      finalize: false,
      step: 0,
      order: undefined,
      loading: undefined,
      code: undefined,
      salesResponse: undefined,
      validacaoFraude: undefined,
      on: true,
      msgErrorResp: undefined,
    };
  },
  computed: {
    contractId() {
      return this.$route.params.contractId;
    },
    planId() {
      return this.$route.params.planId;
    },
    contract() {
      return this.$store.getters.getContractById(this.contractId);
    },
    user() {
      return auth.currentUser;
    },
  },

  methods: {
    startRequest() {
      this.on = false;
      const summary = this.$refs.rechargeSummary;
      const r = summary
        ? summary.getInfos().then(() => this.duplicityCheck())
        : this.duplicityCheck();
      this.loading = r;
      this.$store.dispatch("loading", r);
    },
    goToStep(value) {
      this.code = undefined;
      this.finalize = false;
      this.step = value;
    },
    nextStep() {
      this.msgError = undefined;
      $("body").stop().animate(
        {
          scrollTop: 0,
        },
        "500",
        "swing",
      );
      switch (this.step) {
        case 0:
          let p = this.$refs.rec.getSalesOrder().then((r) => {
            if (!r) {
              return;
            }
            this.order = r;
            this.order.planId = this.planId;
            if (!this.order.vehicles) {
              this.$set(this.order, "vehicles", []);
            }
            this.step = 1;
          });
          this.$store.dispatch("loading", p);
          break;
      }
    },

    duplicityCheck() {
      return sales
        .getProcessingOrders(this.contractId, "RECHARGE")
        .then((r) => {
          if (r == 0 || this.planId == 6) {
            return this.doRecharge();
          } else {
            const n = Number(r);
            const count = Number.isFinite(n) && n > 0 ? n : 1;
            const body =
              count === 1
                ? "Já existe <strong>1 pedido de recarga</strong> em processamento para este contrato. Deseja prosseguir com uma nova recarga?"
                : `Já existem <strong>${count} pedidos de recarga</strong> em processamento para este contrato. Deseja prosseguir com uma nova recarga?`;
            return messageDialog
              .show({
                title: "Recarga em processamento",
                headerClass: "modal-danger",
                message: body,
                type: "YES-NO",
              })
              .then((e) => e == "YES" && this.doRecharge());
          }
        });
    },
    doRecharge() {
      let request = {
        recharge: {
          contractId: this.contractId,
          _interface: window.document.webview ? "MOBILE" : "WEBSITE",
          value: this.order.value,
        },
      };

      let p = sales
        .recharge(request)
        .then((resp) => {
          this.salesResponse = resp.salesOrder;
          this.code = resp.status.code;
          this.finalize = true;
          $("body").stop().animate({ scrollTop: 0 }, "500", "swing");
          this.showMessage(resp);
        })
        .catch((err) => {
          this.finalize = true;
          this.salesResponse = err.salesOrder;

          this.validacaoFraude = false;

          if (err.data) {
            this.salesResponse = err.data.salesOrder;
            this.code = err.data.status.code;
            this.msgError = err.data.status.message;
          } else {
            this.code = 1;
          }
        });
      return p;
    },
    showMessage(resp) {
      let code = (this.code = resp.status.code);
      if (code == 0) {
        let title = "";
        let msg = resp.status.message;
        if (resp && resp.redirUrl) {
          title = "Estamos quase lá";
        } else {
          title = "Recarga realizada com sucesso";
        }
        messageDialog
          .show({
            title: title,
            headerClass: "modal-success",
            message: msg,
          })
          .then((res) => {
            if (resp && resp.redirUrl) {
              window.location = resp.redirUrl;
            } else {
              this.$router.push({
                name: "requests",
              });
            }
          });
        return;
      }
    },
  },

  components: {
    RechargeMultiple,
    RechargeOpen,
    RechargeTax,
    GenericSummary,
    successPage,
    errorPage,
  },
};



// WEBPACK FOOTER //
// ./src/pages/account/recharge/recharge.js